export const LEGACY_LISTLESS_GROUP_PLACEMENT_KEY =
  "judi-listless-group-placement";

/** Where the board puts tasks that have no list, relative to the list columns. */
export type ListlessGroupPlacement = "start" | "end";

export function parseListlessGroupPlacement(
  value: unknown,
): ListlessGroupPlacement {
  return value === "start" || value === "end" ? value : "end";
}

/** One-time read of the dedicated key used before this lived in UI preferences. */
export function readLegacyListlessGroupPlacement(): ListlessGroupPlacement | null {
  try {
    const stored = localStorage.getItem(LEGACY_LISTLESS_GROUP_PLACEMENT_KEY);
    if (stored === "start" || stored === "end") return stored;
  } catch {
    // Private mode / blocked storage.
  }
  return null;
}

/**
 * Put the no-list group at the start or the end of the list groups.
 * Used by the board layout, prev/next task order, and the reorder dialog.
 */
export function arrangeByPlacement<T>(
  listItems: T[],
  listlessItems: T[],
  placement: ListlessGroupPlacement,
): T[] {
  return placement === "start"
    ? [...listlessItems, ...listItems]
    : [...listItems, ...listlessItems];
}
